import { useState, useEffect } from 'react';

const ContactForm = () => {
    const [formEnabled, setFormEnabled] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject]= useState('');
    const [message, setMessage] = useState('');

    useEffect(()=>{
        if (name && email && subject && message){
            setFormEnabled(true);
        }
        else{
            setFormEnabled(false);
        }

    },[name, email, subject, message])
    return ( 
        <form name="contact" method="post" id="contactForm" data-netlify="true">
            <input type="text" name="Name" placeholder="*Name" value={name} onChange={e=>{setName(e.target.value)}}/>
            <input type="email" name="Email" placeholder="*Email" value={email} onChange={e=>{setEmail(e.target.value)}}/>
            <input type="text" name="Subject" placeholder="*Subject" value={subject} onChange={e=>{setSubject(e.target.value)}}/>
            <textarea name="Message" placeholder="*Message" rows="5" value={message} onChange={e=>{setMessage(e.target.value)}}></textarea>
            <button disabled={!formEnabled} value="submit" className={formEnabled?"btn-submit":"btn-disabled"} onClick={e=>
            {e.preventDefault();
                setFormEnabled(false);
                setName('');
                setEmail('');
                setSubject('');
                setMessage('');
                
            }}>SEND</button>
        </form>
     );
}
 
export default ContactForm;